import React, { useEffect } from 'react'

const Step5 = ({formData,setFormData}) => {
    useEffect(() => {
          console.log(formData)
      }, [formData])
  return (
    <div className='w-full flex flex-col ' style={{direction:"rtl"}}>
        <p>9.אנא תאר בקצרה כיצד נכווה הילד בכוויה בגללה הגעתם לבית החולים</p>
        <textarea type='text' placeholder='טקסט חופשי' className='w-full outline-none text-Black min-h-64  bg-LightBlue focus:ring-0 focus:border-2 p-2 focus:border-MidBlue' onChange={(e)=>setFormData({...formData,q9:e.currentTarget.value})}/>    </div>
  )
}

export default Step5